var _rect, _rect2, _rect3, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConditionManagementBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19491_33098)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "url(#paint0_linear_19491_33098)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19491_33098",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 76
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 76,
    rx: 11,
    fill: "#E9F7EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 334,
    height: 75,
    rx: 10.5,
    stroke: "url(#paint1_linear_19491_33098)",
    strokeOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19491_33098)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: 108,
    cy: -19,
    r: 102,
    fill: "#6544C6",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: -18,
    cy: -22,
    r: 101.9,
    stroke: "url(#paint2_linear_19491_33098)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M199.9 -19C199.9 31.755 158.755 72.9 108 72.9C57.245 72.9 16.1 31.755 16.1 -19C16.1 -69.755 57.245 -110.9 108 -110.9C158.755 -110.9 199.9 -69.755 199.9 -19Z",
    fill: "#6544C6",
    fillOpacity: 0.4,
    stroke: "url(#paint3_linear_19491_33098)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M189.9 -19C189.9 26.2321 153.232 62.9 108 62.9C62.7679 62.9 26.1 26.2321 26.1 -19C26.1 -64.2321 62.7679 -100.9 108 -100.9C153.232 -100.9 189.9 -64.2321 189.9 -19Z",
    fill: "#6544C6",
    fillOpacity: 0.4,
    stroke: "url(#paint4_linear_19491_33098)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M178.9 -19C178.9 20.157 147.157 51.9 108 51.9C68.843 51.9 37.1 20.157 37.1 -19C37.1 -58.157 68.843 -89.9 108 -89.9C147.157 -89.9 178.9 -58.157 178.9 -19Z",
    fill: "#6544C6",
    fillOpacity: 0.4,
    stroke: "url(#paint5_linear_19491_33098)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M168.9 -19C168.9 14.6341 141.634 41.9 108 41.9C74.3659 41.9 47.1 14.6341 47.1 -19C47.1 -52.6341 74.3659 -79.9 108 -79.9C141.634 -79.9 168.9 -52.6341 168.9 -19Z",
    fill: "#6544C6",
    fillOpacity: 0.4,
    stroke: "url(#paint6_linear_19491_33098)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M158.9 -19C158.9 9.11129 136.111 31.9 108 31.9C79.8887 31.9 57.1 9.11129 57.1 -19C57.1 -47.1113 79.8887 -69.9 108 -69.9C136.111 -69.9 158.9 -47.1113 158.9 -19Z",
    fill: "#6544C6",
    fillOpacity: 0.4,
    stroke: "url(#paint7_linear_19491_33098)",
    strokeWidth: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-11-outside-1_19491_33098",
    maskUnits: "userSpaceOnUse",
    x: 237.294,
    y: -0.717773,
    width: 104,
    height: 104,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 237.294,
    y: -0.717773,
    width: 104,
    height: 104
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.835 41.8203V32.1403C305.835 31.136 305.024 30.3253 304.02 30.3253H296.155V22.4603C296.155 21.456 295.344 20.6453 294.34 20.6453H284.66C283.656 20.6453 282.845 21.456 282.845 22.4603V30.3253H274.98C273.976 30.3253 273.165 31.136 273.165 32.1403V41.8203C273.165 42.8246 273.976 43.6353 274.98 43.6353H282.845V51.5003C282.845 52.5046 283.656 53.3153 284.66 53.3153H294.34C295.344 53.3153 296.155 52.5046 296.155 51.5003V43.6353H304.02C305.024 43.6353 305.835 42.8246 305.835 41.8203ZM302.205 40.0053H294.34C293.336 40.0053 292.525 40.816 292.525 41.8203V49.6853H286.475V41.8203C286.475 40.816 285.664 40.0053 284.66 40.0053H276.795V33.9553H284.66C285.664 33.9553 286.475 33.1446 286.475 32.1403V24.2753H292.525V32.1403C292.525 33.1446 293.336 33.9553 294.34 33.9553H302.205V40.0053ZM337.295 52.1173C335.819 50.6411 333.774 49.7942 331.693 49.7942C329.587 49.7942 327.603 50.6169 326.09 52.1173L310.663 67.5448C310.663 67.4359 310.675 67.3392 310.675 67.2303C310.675 63.927 308.63 61.1077 305.75 59.934L325.57 40.574C330.011 36.2422 332.455 30.4584 332.455 24.2874C332.455 18.1164 330.011 12.3205 325.57 7.98865C316.398 -0.953248 301.491 -0.953248 292.319 7.98865L289.56 10.808L286.681 7.98865C282.24 3.66895 276.335 1.28525 270.055 1.28525C263.775 1.28525 257.87 3.66895 253.43 7.98865C248.989 12.3326 246.533 18.1285 246.545 24.2995C246.545 30.4705 248.989 36.2543 253.43 40.5861L272.669 59.3773H270.2C264.997 59.3773 260.109 61.3981 256.431 65.0886L251.276 70.2431C249.546 69.263 247.21 69.4688 245.77 70.9087L239.829 76.8497C239.115 77.5636 239.115 78.7132 239.829 79.415C240.543 80.1289 241.693 80.1289 242.395 79.415L248.336 73.4739C248.687 73.123 249.267 73.123 249.618 73.4739L269.97 93.8261C270.2 94.056 270.237 94.3343 270.237 94.4674C270.237 94.6005 270.2 94.8788 269.97 95.1087L266.449 98.6298C265.735 99.3437 265.735 100.493 266.449 101.195C266.8 101.546 267.272 101.727 267.732 101.727C268.192 101.727 268.664 101.546 269.015 101.195L272.536 97.6739C274.036 96.1735 274.254 93.8987 273.213 92.1563L274.593 90.7769C275.343 90.0267 276.323 89.6274 277.376 89.6274H304.08C309.15 89.6274 314.075 87.5341 317.584 83.8678L337.404 63.2252C340.38 60.1276 340.332 55.1544 337.295 52.1173ZM255.971 37.9846C252.232 34.3425 250.175 29.4783 250.175 24.2995C250.175 19.1086 252.232 14.2444 255.971 10.5902C259.722 6.93595 264.731 4.92735 270.055 4.92735C275.379 4.92735 280.389 6.93595 284.14 10.5902L287.019 13.4095C288.387 14.7526 290.613 14.7526 291.992 13.4095L294.872 10.5902C302.64 3.01555 315.273 3.01555 323.041 10.5902C326.78 14.2444 328.837 19.1086 328.837 24.2995C328.837 29.4904 326.78 34.3546 323.041 37.9967L301.14 59.3653H277.86L255.971 37.9846ZM334.79 60.6962L314.958 81.351C312.127 84.3034 308.158 85.9853 304.068 85.9853H277.364C275.343 85.9853 273.443 86.7718 272.003 88.1996L270.733 89.4701L253.95 72.6753L258.984 67.6417C261.972 64.653 265.953 62.9953 270.188 62.9953H277.109H301.866H302.81C305.145 62.9953 307.045 64.895 307.045 67.2303C307.045 69.4688 305.302 71.2838 303.1 71.4411C302.895 71.4532 302.701 71.4653 302.495 71.4653H284.66C283.656 71.4653 282.845 72.276 282.845 73.2803C282.845 74.2846 283.656 75.0953 284.66 75.0953H302.495H302.81C303.124 75.0953 303.439 75.071 303.742 75.0347C306.972 74.7443 309.985 73.3529 312.308 71.0297L328.655 54.6826C329.478 53.8719 330.567 53.4121 331.705 53.4121C332.83 53.4121 333.943 53.8719 334.742 54.6705C336.375 56.3282 336.399 59.0264 334.79 60.6962Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.835 41.8203V32.1403C305.835 31.136 305.024 30.3253 304.02 30.3253H296.155V22.4603C296.155 21.456 295.344 20.6453 294.34 20.6453H284.66C283.656 20.6453 282.845 21.456 282.845 22.4603V30.3253H274.98C273.976 30.3253 273.165 31.136 273.165 32.1403V41.8203C273.165 42.8246 273.976 43.6353 274.98 43.6353H282.845V51.5003C282.845 52.5046 283.656 53.3153 284.66 53.3153H294.34C295.344 53.3153 296.155 52.5046 296.155 51.5003V43.6353H304.02C305.024 43.6353 305.835 42.8246 305.835 41.8203ZM302.205 40.0053H294.34C293.336 40.0053 292.525 40.816 292.525 41.8203V49.6853H286.475V41.8203C286.475 40.816 285.664 40.0053 284.66 40.0053H276.795V33.9553H284.66C285.664 33.9553 286.475 33.1446 286.475 32.1403V24.2753H292.525V32.1403C292.525 33.1446 293.336 33.9553 294.34 33.9553H302.205V40.0053ZM337.295 52.1173C335.819 50.6411 333.774 49.7942 331.693 49.7942C329.587 49.7942 327.603 50.6169 326.09 52.1173L310.663 67.5448C310.663 67.4359 310.675 67.3392 310.675 67.2303C310.675 63.927 308.63 61.1077 305.75 59.934L325.57 40.574C330.011 36.2422 332.455 30.4584 332.455 24.2874C332.455 18.1164 330.011 12.3205 325.57 7.98865C316.398 -0.953248 301.491 -0.953248 292.319 7.98865L289.56 10.808L286.681 7.98865C282.24 3.66895 276.335 1.28525 270.055 1.28525C263.775 1.28525 257.87 3.66895 253.43 7.98865C248.989 12.3326 246.533 18.1285 246.545 24.2995C246.545 30.4705 248.989 36.2543 253.43 40.5861L272.669 59.3773H270.2C264.997 59.3773 260.109 61.3981 256.431 65.0886L251.276 70.2431C249.546 69.263 247.21 69.4688 245.77 70.9087L239.829 76.8497C239.115 77.5636 239.115 78.7132 239.829 79.415C240.543 80.1289 241.693 80.1289 242.395 79.415L248.336 73.4739C248.687 73.123 249.267 73.123 249.618 73.4739L269.97 93.8261C270.2 94.056 270.237 94.3343 270.237 94.4674C270.237 94.6005 270.2 94.8788 269.97 95.1087L266.449 98.6298C265.735 99.3437 265.735 100.493 266.449 101.195C266.8 101.546 267.272 101.727 267.732 101.727C268.192 101.727 268.664 101.546 269.015 101.195L272.536 97.6739C274.036 96.1735 274.254 93.8987 273.213 92.1563L274.593 90.7769C275.343 90.0267 276.323 89.6274 277.376 89.6274H304.08C309.15 89.6274 314.075 87.5341 317.584 83.8678L337.404 63.2252C340.38 60.1276 340.332 55.1544 337.295 52.1173ZM255.971 37.9846C252.232 34.3425 250.175 29.4783 250.175 24.2995C250.175 19.1086 252.232 14.2444 255.971 10.5902C259.722 6.93595 264.731 4.92735 270.055 4.92735C275.379 4.92735 280.389 6.93595 284.14 10.5902L287.019 13.4095C288.387 14.7526 290.613 14.7526 291.992 13.4095L294.872 10.5902C302.64 3.01555 315.273 3.01555 323.041 10.5902C326.78 14.2444 328.837 19.1086 328.837 24.2995C328.837 29.4904 326.78 34.3546 323.041 37.9967L301.14 59.3653H277.86L255.971 37.9846ZM334.79 60.6962L314.958 81.351C312.127 84.3034 308.158 85.9853 304.068 85.9853H277.364C275.343 85.9853 273.443 86.7718 272.003 88.1996L270.733 89.4701L253.95 72.6753L258.984 67.6417C261.972 64.653 265.953 62.9953 270.188 62.9953H277.109H301.866H302.81C305.145 62.9953 307.045 64.895 307.045 67.2303C307.045 69.4688 305.302 71.2838 303.1 71.4411C302.895 71.4532 302.701 71.4653 302.495 71.4653H284.66C283.656 71.4653 282.845 72.276 282.845 73.2803C282.845 74.2846 283.656 75.0953 284.66 75.0953H302.495H302.81C303.124 75.0953 303.439 75.071 303.742 75.0347C306.972 74.7443 309.985 73.3529 312.308 71.0297L328.655 54.6826C329.478 53.8719 330.567 53.4121 331.705 53.4121C332.83 53.4121 333.943 53.8719 334.742 54.6705C336.375 56.3282 336.399 59.0264 334.79 60.6962Z",
    fill: "#006B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.835 41.8203V32.1403C305.835 31.136 305.024 30.3253 304.02 30.3253H296.155V22.4603C296.155 21.456 295.344 20.6453 294.34 20.6453H284.66C283.656 20.6453 282.845 21.456 282.845 22.4603V30.3253H274.98C273.976 30.3253 273.165 31.136 273.165 32.1403V41.8203C273.165 42.8246 273.976 43.6353 274.98 43.6353H282.845V51.5003C282.845 52.5046 283.656 53.3153 284.66 53.3153H294.34C295.344 53.3153 296.155 52.5046 296.155 51.5003V43.6353H304.02C305.024 43.6353 305.835 42.8246 305.835 41.8203ZM302.205 40.0053H294.34C293.336 40.0053 292.525 40.816 292.525 41.8203V49.6853H286.475V41.8203C286.475 40.816 285.664 40.0053 284.66 40.0053H276.795V33.9553H284.66C285.664 33.9553 286.475 33.1446 286.475 32.1403V24.2753H292.525V32.1403C292.525 33.1446 293.336 33.9553 294.34 33.9553H302.205V40.0053ZM337.295 52.1173C335.819 50.6411 333.774 49.7942 331.693 49.7942C329.587 49.7942 327.603 50.6169 326.09 52.1173L310.663 67.5448C310.663 67.4359 310.675 67.3392 310.675 67.2303C310.675 63.927 308.63 61.1077 305.75 59.934L325.57 40.574C330.011 36.2422 332.455 30.4584 332.455 24.2874C332.455 18.1164 330.011 12.3205 325.57 7.98865C316.398 -0.953248 301.491 -0.953248 292.319 7.98865L289.56 10.808L286.681 7.98865C282.24 3.66895 276.335 1.28525 270.055 1.28525C263.775 1.28525 257.87 3.66895 253.43 7.98865C248.989 12.3326 246.533 18.1285 246.545 24.2995C246.545 30.4705 248.989 36.2543 253.43 40.5861L272.669 59.3773H270.2C264.997 59.3773 260.109 61.3981 256.431 65.0886L251.276 70.2431C249.546 69.263 247.21 69.4688 245.77 70.9087L239.829 76.8497C239.115 77.5636 239.115 78.7132 239.829 79.415C240.543 80.1289 241.693 80.1289 242.395 79.415L248.336 73.4739C248.687 73.123 249.267 73.123 249.618 73.4739L269.97 93.8261C270.2 94.056 270.237 94.3343 270.237 94.4674C270.237 94.6005 270.2 94.8788 269.97 95.1087L266.449 98.6298C265.735 99.3437 265.735 100.493 266.449 101.195C266.8 101.546 267.272 101.727 267.732 101.727C268.192 101.727 268.664 101.546 269.015 101.195L272.536 97.6739C274.036 96.1735 274.254 93.8987 273.213 92.1563L274.593 90.7769C275.343 90.0267 276.323 89.6274 277.376 89.6274H304.08C309.15 89.6274 314.075 87.5341 317.584 83.8678L337.404 63.2252C340.38 60.1276 340.332 55.1544 337.295 52.1173ZM255.971 37.9846C252.232 34.3425 250.175 29.4783 250.175 24.2995C250.175 19.1086 252.232 14.2444 255.971 10.5902C259.722 6.93595 264.731 4.92735 270.055 4.92735C275.379 4.92735 280.389 6.93595 284.14 10.5902L287.019 13.4095C288.387 14.7526 290.613 14.7526 291.992 13.4095L294.872 10.5902C302.64 3.01555 315.273 3.01555 323.041 10.5902C326.78 14.2444 328.837 19.1086 328.837 24.2995C328.837 29.4904 326.78 34.3546 323.041 37.9967L301.14 59.3653H277.86L255.971 37.9846ZM334.79 60.6962L314.958 81.351C312.127 84.3034 308.158 85.9853 304.068 85.9853H277.364C275.343 85.9853 273.443 86.7718 272.003 88.1996L270.733 89.4701L253.95 72.6753L258.984 67.6417C261.972 64.653 265.953 62.9953 270.188 62.9953H277.109H301.866H302.81C305.145 62.9953 307.045 64.895 307.045 67.2303C307.045 69.4688 305.302 71.2838 303.1 71.4411C302.895 71.4532 302.701 71.4653 302.495 71.4653H284.66C283.656 71.4653 282.845 72.276 282.845 73.2803C282.845 74.2846 283.656 75.0953 284.66 75.0953H302.495H302.81C303.124 75.0953 303.439 75.071 303.742 75.0347C306.972 74.7443 309.985 73.3529 312.308 71.0297L328.655 54.6826C329.478 53.8719 330.567 53.4121 331.705 53.4121C332.83 53.4121 333.943 53.8719 334.742 54.6705C336.375 56.3282 336.399 59.0264 334.79 60.6962Z",
    stroke: "#006B9B",
    strokeWidth: 2.4,
    mask: "url(#path-11-outside-1_19491_33098)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19491_33098",
    x1: 21,
    y1: 4.99206,
    x2: 212.05,
    y2: 129.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19491_33098",
    x1: -4.7111e-7,
    y1: 1.9,
    x2: 168.119,
    y2: 210.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7EDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19491_33098",
    x1: 71.5,
    y1: 38,
    x2: -70,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19491_33098",
    x1: 188.725,
    y1: 35.1176,
    x2: 61.098,
    y2: -19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19491_33098",
    x1: 179.951,
    y1: 29.2353,
    x2: 66.1961,
    y2: -19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19491_33098",
    x1: 170.299,
    y1: 22.7647,
    x2: 71.8039,
    y2: -19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19491_33098",
    x1: 161.525,
    y1: 16.8823,
    x2: 76.902,
    y2: -19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19491_33098",
    x1: 152.75,
    y1: 11,
    x2: 82,
    y2: -19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19491_33098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionManagementBg);
export default __webpack_public_path__ + "static/media/Condition-Management-Bg.1946309ff7d343e7a94df65991598534.svg";
export { ForwardRef as ReactComponent };